{
  "CHAT_LIST": {
    "LOADING": "Загружаем диалоги",
    "LOAD_MORE_CONVERSATIONS": "Загрузить больше диалогов",
    "EOF": "Все диалоги загружены 🎉",
    "LIST": {
      "404": "В этой группе нет активных диалогов."
    },
    "FAILED_TO_SEND": "Не удалось отправить",
    "TAB_HEADING": "Диалоги",
    "MENTION_HEADING": "Упоминания",
    "UNATTENDED_HEADING": "Неотвеченные",
    "SEARCH": {
      "INPUT": "Искать людей, чаты, сохраненные ответы .."
    },
    "FILTER_ALL": "Все",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Мои",
      "unassigned": "Неназначен",
      "all": "Все"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Открыт"
      },
      "resolved": {
        "TEXT": "Закрыт"
      },
      "pending": {
        "TEXT": "В ожидании"
      },
      "snoozed": {
        "TEXT": "Отложено"
      },
      "all": {
        "TEXT": "Все"
      }
    },
    "VIEW_FILTER": "Просмотр",
    "SORT_TOOLTIP_LABEL": "Сортировать сообщения",
    "CHAT_SORT": {
      "STATUS": "Статус",
      "ORDER_BY": "Сортировать по"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Создан",
        "OLDEST": "Дата создания:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Последние действия:",
        "ACTIVE": "Последние действия"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Последняя активность: сначала старые"
      },
      "last_activity_at_desc": {
        "TEXT": "Последняя активность: сначала новые"
      },
      "created_at_desc": {
        "TEXT": "Создано: сначала новые"
      },
      "created_at_asc": {
        "TEXT": "Создано: сначала старые"
      },
      "priority_desc": {
        "TEXT": "Приоритет: сначала высокие"
      },
      "priority_asc": {
        "TEXT": "Приоритет: сначала низкие"
      },
      "waiting_since_asc": {
        "TEXT": "Ожидающие ответа: сначала старые"
      },
      "waiting_since_desc": {
        "TEXT": "Ожидающие ответа: сначала новые"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Приоритет: Сначала высокие, Создано: Сначала старые"
      },
      "unread": {
        "TEXT": "Unread Count: Highest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Изображение"
      },
      "audio": {
        "CONTENT": "Аудиосообщение"
      },
      "video": {
        "CONTENT": "Видео"
      },
      "file": {
        "CONTENT": "Прикрепленный файл"
      },
      "location": {
        "CONTENT": "Местоположение"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "поделился ссылкой"
      },
      "contact": {
        "CONTENT": "Общий контакт"
      },
      "embed": {
        "CONTENT": "Встроенный контент"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Сортировать диалог",
      "DROPDOWN_TITLE": "Сортировать по",
      "ITEMS": {
        "LATEST": {
          "NAME": "Последняя активность",
          "LABEL": "Последние действия"
        },
        "CREATED_AT": {
          "NAME": "Дата создания",
          "LABEL": "Дата создания"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Последнее сообщение пользователя",
          "LABEL": "Последнее сообщение"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Получено по email",
    "VIEW_TWEET_IN_TWITTER": "Просмотреть твит в Twitter",
    "REPLY_TO_TWEET": "Ответить на этот твит",
    "LINK_TO_STORY": "Перейти к истории Instagram",
    "SENT": "Успешно отправлено",
    "READ": "Успешно прочитано",
    "DELIVERED": "Доставлено успешно",
    "NO_MESSAGES": "Нет сообщений",
    "NO_CONTENT": "Содержимое отсутствует",
    "HIDE_QUOTED_TEXT": "Скрыть цитируемый текст",
    "SHOW_QUOTED_TEXT": "Показать цитируемый текст",
    "MESSAGE_READ": "Прочитано",
    "SENDING": "Отправка",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
